
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()

export class CompostService {

  compostHost = environment.config.compostUrl;
  static = environment.config.vendorStaticUrl;

  companyId;

  constructor(private http: HttpClient) { }

  // Compost
  // manufactureRegisterForm(data) {
  registerManufacturer(data) {
    return this.http.post<any>(this.compostHost + 'compost', data);
  }

  addCompost(data) {
    return this.http.post(this.compostHost + 'compost', data);
  }
  updateCompost(data, id) {
    return this.http.put(this.compostHost + 'compost' + id, data);
  }


  // getPlantFormData() {
  //   return this.http.get<any>(this.getManufactureFormUrl);
  // }

  // plantInfoForm(data) {
  //   return this.http.post<any>(this.plantInfoUrl, data);
  // }
  // getPlants() {
  //   return this.http.get<any>(this.getPlantsUrl);
  // }
  // getPlantDetail(id) {
  //   return this.http.get<any>(this.getPlantListUrl + '/' + id);
  // }
  // getPlantList(data) {
  //   return this.http.post<any>(this.getPlantListUrl, data);
  // }
  // addWaste(data) {
  //   return this.http.post<any>(this.addWasteUrl, data);
  // }
  // getWasteList(data) {
  //   return this.http.post<any>(this.wasteListUrl, data);
  // }

  // getMonthlyWasteList() {
  //   return this.http.get<any>(this.monthlyWasteListUrl);
  // }

  // getCompostList(data) {
  //   return this.http.post<any>(this.compostListUrl, data);
  // }

  // addSellInfoForms(data) {
  //   return this.http.post<any>(this.addSellInfoUrl, data);
  // }

  // getSellInfoList() {
  //   return this.http.get<any>(this.sellInfoListUrl);
  // }

  // plantInformationForm() {
  //   return this.http.get<any>(this.plantInfoFormUrl);
  // }
  // compostFilter(data) {
  //   return this.http.post<any>(this.compostFilterUrl, data);
  // }

  // wasteFilter(data) {
  //   return this.http.post<any>(this.wasteFilterUrl, data);
  // }

  // createSell_compost(data) {
  //   console.log('??????????', data);
  //   return this.http.post<any>(this.createSell_compostUrl, data);
  // }

  // wasteUpdateID(data) {
  //   return this.http.post<any>(this.wasteUpdateIDUrl, data);
  // }

  // compostUpdateID(data) {
  //   return this.http.post<any>(this.compostUpdateIDUrl, data);
  // }

  // updateWaste(data) {
  //   return this.http.post<any>(this.compostUpdateUrl, data);
  // }

  // getSellData(data) {
  //   return this.http.post<any>(this.getSellDataUrl, data);
  // }

  // sellInfoID(data) {
  //   return this.http.post<any>(this.sellInfoIDUrl, data);
  // }

  // sellFilter(data) {
  //   return this.http.post<any>(this.sellFilterUrl, data);
  // }

  // getCompanyList(data) {
  //   return this.http.post<any>(this.companyListUrl, data);
  // }

  // companyListSearch(data) {
  //   // search
  //   return this.http.post<any>(this.companyListSearchUrl, data);
  // }

  // getViewPlantList(data) {
  //   return this.http.post<any>(this.viewPlantListUrl, data);
  // }

  // viewPlantSearch(data) {
  //   // search
  //   return this.http.post<any>(this.viewPlantListSearchUrl, data);
  // }

  // getCompostProductionList() {
  //   return this.http.get<any>(this.compostProductionListUrl);
  // }

  // compostProductionSearch(data) {
  //   // search
  //   return this.http.post<any>(this.compostProductionSearchUrl, data);
  // }

  // plantInfo(data) {
  //   return this.http.post<any>(this.plantInformationUrl, data);
  // }

  // viewCompanyList(id) {
  //   return this.http.post<any>(this.viewCompanyListUrl, { userId: id });
  // }

  // getVerifyCompostList() {
  //   return this.http.get<any>(this.getVerifyCompostListUrl);
  // }

  // verifyCompostData(data) {
  //   return this.http.post<any>(this.verifyCompostDataUrl, data);
  // }

  // verifyCompostFilter(data) {
  //   return this.http.post<any>(this.verifyCompostFilterUrl, data);
  // }

  // getallplant() {
  //   return this.http.get<any>(this.getallplantUrl);
  // }
  // getCompanyBasicDetail() {
  //   return this.http.get<any>(this.getManufacturerUrl);
  // }
  // getUlbCompanyOptions() {
  //   return this.http.get<any>(this.getCompanyListUrl);
  // }

  // viewCompanyListSubmit(data) {
  //   return this.http.post<any>(this.viewCompanyListSubmitUrl, data);
  // }
  // updateDirectorsInfo(data) {
  //   return this.http.post<any>(this.updateDirectorsUrl, data);
  // }

  // getDataForSale(id) {
  //   return this.http.get<any>(this.getDataForSaleUrl + '/' + id);
  // }

  // getDashboardData() {
  //   return this.http.get<any>(this.dashboardUrl);
  // }

}
